import { shortcodeAcc, menuAcc } from '../__shortcodes/accordions';
import Tabs from '../__page/tabs';
import GalleryLightbox from '../__page/lightboxGallery';
import bindScrollEvents from '../__utils/lockScroll';
import Video from '../__utils/video';
import { SimpleSlider, LightboxSlider } from '../__utils/sliders';
import Tables from '../__utils/tables';
import initSearch from '../__utils/searchInput';
import initToggle from '../__header/toggleMenu';
import Header from '../__header/header';
import headerImageInit from '../__header/headerImages';
import { initMessage, loadMessage } from '../__utils/alertMessage/alertMessage';
import { initCookie } from '../__utils/alertMessage/alertCookie';
import drawLine from '../__utils/_animate/inviewAnimateController';
import { excerpt, changeHeight } from '../__utils/textExcerpt';
import initSlider from '../__utils/numbersSlider';
import { evenPost, evenLinks, blogPost } from '../__utils/_alignment/alignmentController';
import initDraw from '../__utils/_animate/animateLine';
import socialInit from '../__utils/socialShare';
import fixedSocial from '../__utils/sticky-social';
import { setPagination, searchPagination } from '../__archive/pagination';
import { filterTrigger } from '../__archive/filterToggle';
import initPagAjax from '../__archive/ajaxLoad';
import formSelect from '../__utils/formElements';
import UpcomingEvents from '../__page/upcomingEvents';
import smoothScroll from '../__utils/smoothScroll';
import SearchOverlay from '../__search/searchOverlay';
import formDatePicker from '../__utils/formDatePicker';
import CalendarFilters from '../__utils/calendarFilters';

const headerGlobal = new Header();

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        document.querySelector('html').classList.remove('no-js');
        formSelect();
        formDatePicker();
        initCookie();
        headerImageInit();
        shortcodeAcc.init();
        menuAcc.menuAccordion();
        Tabs.init();
        bindScrollEvents();
        Video();
        SimpleSlider.init();
        LightboxSlider.init();
        GalleryLightbox.init();
        Tables.init();
        initSearch();
        initToggle();
        headerGlobal.init();
        initMessage();
        initCookie();
        drawLine.customInit();
        initSlider();
        evenPost.init();
        evenLinks.init();
        blogPost.init();
        socialInit();
        filterTrigger();
        initPagAjax();
        UpcomingEvents.init();
        smoothScroll();
        SearchOverlay.init();
        searchPagination();
        CalendarFilters.init();
    },
    loaded() {
        document.querySelector('body').classList.add('page-has-loaded');
        loadMessage();
        excerpt();
        fixedSocial();
        setPagination();
    },
    resized() {
        Tables.toggleTablesShadow();
        Tables.responsiveTableWidth();
        fixedSocial();
    },
    scrolled() {
        initDraw();
    },
    orientation() {
        Tables.toggleTablesShadow();
        Tables.responsiveTableWidth();
        // changeHeight();
    },
    orientationMob() {
        changeHeight();
    },
};
export default controller;
